import { render, staticRenderFns } from "./RegReceiptPage.vue?vue&type=template&id=00ac877e&scoped=true&"
import script from "./RegReceiptPage.vue?vue&type=script&lang=js&"
export * from "./RegReceiptPage.vue?vue&type=script&lang=js&"
import style0 from "./RegReceiptPage.vue?vue&type=style&index=0&id=00ac877e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac877e",
  null
  
)

export default component.exports